import React from "react";
import AppState from "../model/AppState";
import CarrinhoModel from "../model/CarrinhoModel";
import { Snackbar } from "@material-ui/core";
import AlertaModel from "../model/AlertaModel";
import { ReactComponent as ImagemHomeAtiva } from "../assets/images/icons/footer/footer-home-ativo.svg";
import { ReactComponent as ImagemHomeInativa } from "../assets/images/icons/footer/footer-home-inativo.svg";
import { ReactComponent as ImagemOfertasAtiva } from "../assets/images/icons/footer/footer-ofertas-ativo.svg";
import { ReactComponent as ImagemOfertasInativa } from "../assets/images/icons/footer/footer-ofertas-inativo.svg";
import { ReactComponent as ImagemCarrinhoCheioAtivo } from "../assets/images/icons/footer/footer-carrinho-cheio-ativo.svg";
import { ReactComponent as ImagemCarrinhoCheioInativo } from "../assets/images/icons/footer/footer-carrinho-cheio-inativo.svg";
import { ReactComponent as ImagemCarrinhoVazioAtivo } from "../assets/images/icons/footer/footer-carrinho-vazio-ativo.svg";
import { ReactComponent as ImagemCarrinhoVazioInativo } from "../assets/images/icons/footer/footer-carrinho-vazio-inativo.svg";
import { ReactComponent as ImagemListaAtivo } from "../assets/images/icons/footer/footer-lista-ativo.svg";
import { ReactComponent as ImagemListaInativo } from "../assets/images/icons/footer/footer-lista-inativo.svg";
import { ReactComponent as ImagemMenuAtivo } from "../assets/images/icons/footer/footer-menu-ativo.svg";
import { ReactComponent as ImagemMenuInativo } from "../assets/images/icons/footer/footer-menu-inativo.svg";
import { ReactComponent as ImagemFeedback } from "../assets/images/icons/footer/footer-feedback.svg";
import NavegadorUtil from "../util/NavegadorUtil";
import LojaModel from "../model/LojaModel";
import ModalFeedback from "./ModalFeedback";
import { Link, withRouter, RouteComponentProps } from "react-router-dom";
import ModalMaioridade from "./ModalMaioridade";

interface IRodapeProps extends RouteComponentProps {
  parent: React.Component;
  ativo: string;
}

type RodapeState = {
  showModalFeedback: boolean;
  modalMaioridadeVisivel: boolean;
};

class Rodape extends React.Component<IRodapeProps, RodapeState> {
  constructor(props: IRodapeProps) {
    super(props);

    this.getMenuLink = this.getMenuLink.bind(this);
    this.irParaCarrinho = this.irParaCarrinho.bind(this);
    this.toggleModalFeedback = this.toggleModalFeedback.bind(this);
    this.hideMaioridade = this.hideMaioridade.bind(this);

    this.state = {
      showModalFeedback: false,
      modalMaioridadeVisivel: false,
    };
  }

  getMenuLink(): string {
    return NavegadorUtil.getUrl(
      AppState.getUsuarioLogado() !== null ? "/menu-logado" : "/menu"
    );
  }

  irParaCarrinho(): void {
    const loja: LojaModel | null = AppState.getLojaSelecionada();
    if (loja && !loja.retirada) {
      NavegadorUtil.alerta(
        this.props.parent,
        "Esta loja não aceita pedidos pelo app.  Favor selecionar outra loja ou dirigir-se até a loja física."
      );
    } else {
      NavegadorUtil.redirect("/carrinho", this.props.history);
    }
  }

  toggleModalFeedback(): void {
    this.setState({ showModalFeedback: !this.state.showModalFeedback });
  }

  hideMaioridade(): void {
    this.setState({ modalMaioridadeVisivel: false });
    if (AppState.getMaioridade() === false) {
      NavegadorUtil.alerta(this, "Este item não é comercializado para menores de idade.");
    }
  }

  render(): any {
    const { ativo } = this.props;
    const { showModalFeedback, modalMaioridadeVisivel } = this.state;
    let alerta: any = AppState.getAlerta();

    if (!alerta) {
      alerta = {
        exibirModal: false,
      } as AlertaModel;
    }

    let cheioFlag: boolean = true;
    const carrinho: CarrinhoModel = AppState.getCarrinho();
    if (carrinho.carrinhoItens.length === 0) {
      cheioFlag = false;
    }

    return (
      <>
        {ativo !== "Produto" && (
          <Snackbar
            open={alerta.exibirModal}
            className="info"
            transitionDuration={1000}
            onClose={() => AppState.fecharAlerta(this)}
            autoHideDuration={6000}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
            message={<span id="message-id">{alerta.mensagem}</span>}
          />
        )}
        {showModalFeedback && (
          <ModalFeedback toggleModalFeedback={this.toggleModalFeedback} />
        )}
        { modalMaioridadeVisivel &&
        <ModalMaioridade visivel={true} save={this.hideMaioridade} />
        }
        <footer
          className="context-menu feedback"
          ref="menuContexto"
          onClick={this.toggleModalFeedback}
        >
          <ImagemFeedback style={{ marginTop: "-5px",  width: "40px", marginLeft: "-2px" }} />
        </footer>
        <footer className="menu">
          <div>
            <Link
              to={NavegadorUtil.getUrl("/home")}
              className={ativo === "Home" ? "active" : ""}
            >
              {ativo === "Home" ? (
                <ImagemHomeAtiva className="home" />
              ) : (
                <ImagemHomeInativa className="home" />
              )}
            </Link>
            <Link
              to={NavegadorUtil.getUrl("/ofertas")}
              className={ativo === "Ofertas" ? "active" : ""}
            >
              {ativo === "Ofertas" ? (
                <ImagemOfertasAtiva className="ofertas" />
              ) : (
                <ImagemOfertasInativa className="ofertas" />
              )}
            </Link>
            <div
              onClick={this.irParaCarrinho}
              id="carrinhoIcone"
              className={ativo === "Carrinho" ? "active" : ""}
              style={{ marginTop: "2px" }}
            >
              {ativo === "Carrinho" ? (
                cheioFlag ? (
                  <ImagemCarrinhoCheioAtivo className="carrinho" />
                ) : (
                  <ImagemCarrinhoVazioAtivo className="carrinho" />
                )
              ) : cheioFlag ? (
                <ImagemCarrinhoCheioInativo className="carrinho" />
              ) : (
                <ImagemCarrinhoVazioInativo className="carrinho" />
              )}
            </div>
            <Link
              to={NavegadorUtil.getUrl("/listas")}
              className={ativo === "Lista" ? "active" : ""}
            >
              {ativo === "Lista" ? (
                <ImagemListaAtivo className="lista" />
              ) : (
                <ImagemListaInativo className="lista" />
              )}
            </Link>
            <Link
              to={this.getMenuLink()}
              className={ativo === "Menu" ? "active" : ""}
            >
              {ativo === "Menu" ? (
                <ImagemMenuAtivo className="menu" />
              ) : (
                <ImagemMenuInativo className="menu" />
              )}
            </Link>
          </div>
        </footer>
      </>
    );
  }
}

export default withRouter(Rodape);
